function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "whatsapp",
  d: "M11.587,9.774c.163.084.267.13.3.2a1.279,1.279,0,0,1-.136.767,1.583,1.583,0,0,1-1.1.728c-.3.013-.306.234-1.924-.474A6.655,6.655,0,0,1,6.049,8.442a3.15,3.15,0,0,1-.6-1.7,1.772,1.772,0,0,1,.618-1.326.485.485,0,0,1,.442-.169h.306c.1,0,.234-.039.357.292l.448,1.215a.3.3,0,0,1,.007.286l-.175.266L7.2,7.584c-.078.078-.169.162-.078.325A4.824,4.824,0,0,0,7.98,9.066a4.3,4.3,0,0,0,1.268.845c.156.091.253.078.351-.026l.526-.611c.123-.162.228-.123.377-.071l1.085.572M8.5,2A6.5,6.5,0,1,1,5.023,13.993L2,15l1.007-3.022A6.5,6.5,0,0,1,8.5,2m0,1.3a5.2,5.2,0,0,0-4.251,8.2l-.624,1.878L5.5,12.751A5.2,5.2,0,1,0,8.5,3.3Z",
  transform: "translate(-2 -2)",
  fill: "#fff"
});

function SvgIconWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Whatsapp",
    "data-name": "Icon - Whatsapp",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.8c3f5cb9.svg";
export { ForwardRef as ReactComponent };